import { useDictionary } from '../../../../../utilities/hooks/UseDictionary';
import image from '../../../../../assets/images/create_experience_new.png';
import { useHistory } from 'react-router-dom';
import React from 'react';

const OnBoardingFirstExperience = () => {
	const dictionary = useDictionary();
	const history = useHistory();

	return (
		<div
			className="onboarding-activity-container"
			data-testid="onboarding-first-experience"
		>
			<div className='onboarding-image-container'>
			<img src={image} className="onboarding-activity-image" />
			</div>
			<div className="onboarding-activity-info-container">
				<div className="onboarding-activity-title font-family-roboto mb-4px fw-500">
					{dictionary.create_first_experience_title}
				</div>
				<div className="text onboarding-descriptions truncate-text-2-line" title={dictionary.create_first_experience_text}>{dictionary.create_first_experience_text}</div>
				<button
					onClick={() => history.push('/experiences')}
					style={{ marginTop: '16px' }}
					className="button font-family-roboto fs-12px"
					data-testid="create-first-experience-button"
				>
					{dictionary.create_first_experience}
				</button>
			</div>
		</div>
	);
};

export default OnBoardingFirstExperience;
